import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import Loading from '../Loading';
import { ErrorAlert, SuccessAlert } from '../middleware/AlertMsg';

const DownloadClosingStock = () => {
  // const baseUrl = 'https://officejeeves.com';
  const baseUrl =process.env.REACT_APP_BASE_URL;
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const [warehouse, setWarehouse] = useState("");
  const [machine, setMachine] = useState("");
  const [refiller, setRefiller] = useState("");
  const [machineid, setMachineId] = useState('');
  const [warehouseid, setWarehouseId] = useState('');
  const [refillerid, setRefillerId] = useState('');
  const [isLoading, setLoading] = useState(false);

  const handleMachineChange = (e) => {
    setMachineId(e.target.value);
    setWarehouseId(''); // Clear the warehouse selection
    setRefillerId(''); // Clear the refiller selection
  };

  const handleWarehouseChange = (e) => {
    setWarehouseId(e.target.value);
    setMachineId(''); // Clear the machine selection
    setRefillerId(''); // Clear the refiller selection
  };

  const handleRefillerChange = (e) => {
    setRefillerId(e.target.value);
    setMachineId(''); // Clear the machine selection
    setWarehouseId(''); // Clear the warehouse selection
  };

  useEffect(() => {
    setLoading(true);
    getAllMachine();
    getAllWarehouse();
    getAllRefiller();
    setLoading(false);
  }, [])

  const getAllMachine = async () => {
    const res = await axios.get(`${baseUrl}/api/Machine`, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
    const machineData = res.data.data;
    setMachine(machineData);
    // console.log('machineData: ', machineData);
  }

  const getAllWarehouse = async () => {
    const res = await axios.get(`${baseUrl}/api/getAllWarehouses/Datalist`, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    const warehouseData = res.data.data;
    setWarehouse(warehouseData)
    // console.log('warehouseData: ', warehouseData);
  }

  const getAllRefiller = async () => {
    const res = await axios.get(`${baseUrl}/api/User/DataList?role=Refiller`, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    const refillerData = res.data.data;
    setRefiller(refillerData);
    // console.log('refillerData: ', refillerData);
  }

  const downloadClosingStock = async (event) => {
    event.preventDefault();
    // let reqUrl = `${baseUrl}/api/refillSheetExportCSV`;

    // if (refillerid) {
    //   reqUrl += `?refiller=${refillerid}`
    // }
    // else if (warehouseid) {
    //   reqUrl += `?warehouse=${warehouseid}`
    // }
    // else if (machineid) {
    //   reqUrl += `?machineid=${machineid}`
    // }
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}/api/refillSheetExportCSV?refiller=${refillerid}&warehouse=${warehouseid}&machineid=${machineid}`,
        {
          headers: { 'Authorization': 'Bearer ' + token }
        })
      console.log("res", res);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "closingStock.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);
      SuccessAlert({
        title: "Success",
        message: "Download Successfully",
      });
    } catch (error) {
      setLoading(false);
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
    }
  }

  return (
    <div>
      {
        isLoading ?
          <Loading /> :
          <>
            <h3 style={{ marginTop: "20px", fontWeight: "bold", fontSize: "20px", textDecoration: "underline" }}>Download Closing Stocks</h3>
            <form style={{ display: 'flex', alignItems: 'end' }}>
              {/* Machine selection */}
              <div className="input-lable-v-div">
                <label>Machine</label>
                <select value={machineid} onChange={handleMachineChange}>
                  <option value="">Select Machine</option>
                  {machine &&
                    machine.map((item, i) => (
                      <option key={item._id} value={item._id}>
                        {item.machine_name}
                      </option>
                    ))}
                </select>
              </div>
              {/* Warehouse selection */}
              <div className="input-lable-v-div">
                <label>Warehouse</label>
                <select value={warehouseid} onChange={handleWarehouseChange}>
                  <option value="">Select Warehouse</option>
                  {warehouse &&
                    warehouse.map((item, i) => (
                      <option key={item._id} value={item._id}>
                        {item.wareHouseName}
                      </option>
                    ))}
                </select>
              </div>
              {/* Refiller selection */}
              <div className="input-lable-v-div">
                <label>Refiller</label>
                <select value={refillerid} onChange={handleRefillerChange}>
                  <option value="">Select Refiller</option>
                  {refiller &&
                    refiller.map((item, i) => (
                      <option key={item._id} value={item.user_id}>
                        {item.first_name} {item.last_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="input-lable-v-div">
                <button onClick={downloadClosingStock} className="submit-btn">
                  Download CSV Report
                </button>
              </div>
            </form>
          </>
      }
    </div>
  )
}

export default DownloadClosingStock